
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import ListingSwiperPhotos from '../../Common/ListingSwiperPhotos/ListingSwiperPhotos';
import WishListIcon from '../../WishListIcon';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import { TickSvgIcon } from '../../Common/Assets/SvgComponent/commonSvgIcon';

// Locale
import messages from '../../../locale/messages';

import { formatURL } from '../../../helpers/formatURL';
import { isRTL } from '../../../helpers/formatLocale';
import { url } from '../../../config';

import cs from '../../../components/commonStyle.css';
import s from './ListingItemList.css';

class ListingItemList extends React.Component {

  static propTypes = {
    formatMessage: PropTypes.func,
    id: PropTypes.number,
    basePrice: PropTypes.number,
    currency: PropTypes.string,
    title: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    personCapacity: PropTypes.number,
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    bookingType: PropTypes.string.isRequired,
    wishListStatus: PropTypes.bool,
    isListOwner: PropTypes.bool,
    personCount: PropTypes.number,
    oneTotalPrice: PropTypes.number,
    userAmenities: PropTypes.array,
    isResultLoading: PropTypes.bool
  };

  render() {
    const { id, basePrice, currency, title, city, state, country, coverPhoto, listPhotos, wishListStatus, isListOwner, userAmenities } = this.props;
    const { isResultLoading, updatedLocale, isMapShow } = this.props;

    let heartIcon = 'heartIcon', personalizedURL = '', startDate, endDate, guestCount, listingURL;
    let photosList = (listPhotos && listPhotos.length > 0) ? listPhotos.slice() : [];

    const personalized = this.props?.personalized;
    const personCapacity = this.props?.personCapacity;
    const personCount = this.props?.personCount;

    const amenitiesList = (userAmenities && userAmenities.length > 0)
      ? userAmenities
      : [];
    const locationText = [state, city].filter(value => value && value.trim()).join(', ');

    startDate = personalized?.startDate ? "?&startdate=" + personalized?.startDate : '';
    endDate = personalized?.endDate ? "&enddate=" + personalized?.endDate : '';
    guestCount = personCapacity && personalized?.startDate ? ("&guests=" + personCount) : ("?&guests=" + personCount);

    personalizedURL = startDate + endDate + guestCount;
    listingURL = "/rooms/" + formatURL(title) + '-' + id + personalizedURL;

    return (
      <div className={cx(s.listItemListContainer, 'mapInfoWindow-')}>
        <div className={cx(s.listPhotoColumn, cs.positionRelative)}>
          {
            !isListOwner && <WishListIcon listId={id} key={id} isChecked={wishListStatus} heartIcon={heartIcon} />
          }
          <ListingSwiperPhotos
            id={id}
            coverPhoto={coverPhoto}
            listPhotos={photosList}
            title={title}
            isMapShow={isMapShow}
            personalizedURL={personalizedURL}
            rtl={isRTL(this.props?.locale)}
            updatedLocale={updatedLocale}
            isResultLoading={isResultLoading}
          />
        </div>

        <a href={listingURL} target={"_blank"} className={s.listInfoColumn}>
          <div>
            <p className={cx(s.listTitle, cs.noMargin)}>{title}</p>
            {locationText && (
              <p className={cx(s.listCity, cs.noMargin)}>
                <TickSvgIcon className={s.cityIcon} />
                {locationText}
              </p>
            )}
          </div>

          {amenitiesList.length > 0 && (
            <div className={s.listAmenities}>
              {amenitiesList.map((item, index) => (
                <span key={index} className={cx(s.amenityTag, 'darkModeFilterNone')}>
                  {item?.listsettings?.image ? (
                    <img
                      src={url + '/images/amenities/' + item.listsettings.image}
                      className={s.amenityIcon}
                    />
                  ) : (
                    item?.listsettings?.itemName && <TickSvgIcon className={s.amenityIcon} />
                  )}
                  {item?.listsettings?.itemName}
                </span>
              ))}
            </div>
          )}

          <p className={cx(s.qrPayment, cs.noMargin)}>
            <TickSvgIcon className={s.qrIcon} />
            <FormattedMessage {...messages.payWithQR} />
          </p>
        </a>

        <div className={s.listPriceColumn}>
          <div className={s.priceWrap}>
            <span className={s.priceValue}>
              <CurrencyConverter amount={basePrice} from={currency} />
            </span>
          </div>
          <span className={s.pricePerNight}>
            / <FormattedMessage {...messages.perNight} />
          </span>
          <a href={listingURL} target={"_blank"} className={s.viewDetailsBtn}>
            <FormattedMessage {...messages.viewDetails} />
          </a>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  isMapShow: state.personalized.showMap,
  personalized: state.personalized,
  locale: state.intl && state.intl.locale,
  formValues: getFormValues('SearchForm')(state),
  totalPrice: state.personalized.totalPrice,
  updatedLocale: state?.intl?.newLocale,
  isResultLoading: state?.search?.isResultLoading,
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(ListingItemList)));
